import { render } from "./deliveryInfo.vue?vue&type=template&id=5b56acd8"
import script from "./deliveryInfo.vue?vue&type=script&lang=js"
export * from "./deliveryInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__